import {
  type UseSuspenseQueryResult,
  useSuspenseQuery,
} from '@tanstack/react-query';

import api from '@/axios';
import { GET_CONTAINER_TYPES_KEY } from '@/keys';
import type { ContainerType } from '@/types/core/container-type';

export const getContainerTypes = async (): Promise<ContainerType[]> => {
  const response = await api.get<ContainerType[]>('/container-types');
  return response.data;
};

export const useGetContainerTypes = (): UseSuspenseQueryResult<
  ContainerType[],
  Error
> =>
  useSuspenseQuery({
    queryKey: GET_CONTAINER_TYPES_KEY,
    queryFn: getContainerTypes,
  });
